import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { ratioFormats } from 'constants/ratioFormats';
import { RatioFormatType, RatioFormatObject } from 'types/RatioFormat';

export const setRatioFormat = createActionCreator(
  'RATIO_FORMAT/SET',
  resolve => (ratioFormat: RatioFormatType) => resolve(ratioFormat)
);
export const ratioFormat = createReducer(RatioFormatType.Youtube, handle => [
  handle(setRatioFormat, (_, { payload }) => payload)
]);
export const getRatioFormat = (state: AppState): RatioFormatType => state.ratioFormat;
export const getRatioFormatObject = (state: AppState): RatioFormatObject =>
  ratioFormats[state.ratioFormat];
